import checkout from "./form12";

const {
  formField12: { provisionLevel, amountSetAside },
} = checkout;

const initialValues12 = {
  [provisionLevel.name]: "",
  [amountSetAside.name]: "",
};

export default initialValues12;
